/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import atoms from 'ctsutheme/components/atoms';
import { RenderElement } from 'components/RenderHelpers';
import { compose, withState } from 'recompose';
import { TE } from 'appconstants';

const { Button } = atoms;

let confirmFn;

const styles1 = theme => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.dark
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  },
  message: {
    display: 'flex',
    color: 'inherit'
  }
});

function RSSConfirmContent(props) {
  const {
    message, onClose, showedit, type, classes, state, setState, name, btn1, hideButton1, btn2, hideButton2, onHover, hoverText1, hoverText2
  } = props;

  return (
    <RenderElement access>
      <DialogContent className="px-3 pt-2 pb-0 m-0">
        <RenderElement access>
          <DialogContentText
            component="div"
            data-id= {`${TE.ID}_${name}${TE.CONFIRM}${TE.MSGCONTAINER}`}
            className={classes.message}
          >
            {message && <div dangerouslySetInnerHTML={{ __html: message }} />}
          </DialogContentText>
        </RenderElement>
      </DialogContent>
      <RenderElement access>
        <DialogActions className="align-center d-block px-3 pt-2 m-0">
          {hideButton1 ? null : <Button
            onClick={() => {
              if (showedit) showedit();
              setState(!state);
            }}
            data-id= {`${TE.ID}_${name}${TE.CONFIRM}${TE.CONFIRMBTN}`}
            className="turquoise mx-1"
            variant="outlined"
            color="primary"
            disabled={state}
            title={onHover ? hoverText1 : (type === 'ATTEST' ? 'I Agree' : btn1 || 'OK')}
          >
            {type === 'ATTEST' ? 'I Agree' : btn1 || 'OK'}
          </Button>}
          {hideButton2 ? null : <Button
            onClick={onClose}
            data-id= {`${TE.ID}_${name}${TE.CONFIRM}${TE.CLOSEBTN}`}
            className="turquoise close mx-1"
            variant="outlined"
            color="primary"
            autoFocus
            title={onHover ? hoverText2 : (btn2 || 'Cancel')}
          >
            {btn2 || 'Cancel'}
          </Button>}
        </DialogActions>
      </RenderElement>
    </RenderElement>
  );
}

RSSConfirmContent.propTypes = {
  message: PropTypes.node,
  onClose: PropTypes.func,
  showedit: PropTypes.func,
  name: PropTypes.string,
  btn1: PropTypes.string,
  btn2: PropTypes.string,
  hideButton1: PropTypes.bool,
  hideButton2: PropTypes.bool
};


RSSConfirmContent.defaultProps = {
  showedit: null,
  message: '',
  onClose: null,
  name: 'default',
  btn1: 'OK',
  btn2: null,
  hideButton1: false,
  hideButton2: false
};

const RSSConfirmContentWrapper = withStyles(styles1)(compose(withState('state', 'setState', false))(RSSConfirmContent));

const styles2 = theme => ({
  margin: {
    margin: theme.spacing(1)
  },
  dialogPaper: {
    minHeight: '10rem',
    minWidth: '400px',
    maxWidth: '600px'
  }
});

class Confirmation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      message: ''
    }
  }

  componentDidMount() {
    confirmFn = this.openConfirmation;
  }

  openConfirmation = ({
    type, title, message, onAction, name, btn1, btn2, hideButton1, hideButton2, onHover, hoverText1, hoverText2
  }) => {
    this.setState({
      open: true,
      activateEdit: onAction,
      message,
      type,
      title,
      name,
      btn1,
      btn2,
      hideButton1,
      hideButton2,
      onHover,
      hoverText1,
      hoverText2
    });
  };

  handleClose = (event, reason) => {
    this.setState({ open: false });
  };

  handleEdit = () => {
    const { activateEdit } = this.state;
    activateEdit();
    this.handleClose();
  };

  render() {
    const { classes } = this.props;
    const {
      type, title, message, open, name, btn1, btn2, hideButton1, hideButton2, onHover, hoverText1, hoverText2
    } = this.state;

    return (
      <RenderElement access>
        <Dialog
          open={open}
          maxWidth="xl"
          classes={{ paper: classes.dialogPaper }}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <RenderElement access>
            <DialogTitle 
            data-id= {`${TE.ID}_${name}${TE.CONFIRM}${TE.TITLE}`} className="px-3 py-2 m-0 bg-turquoise color-white font-bold" id="responsive-dialog-title">
              {title || 'Confirmation'}
            </DialogTitle>
          </RenderElement>
          <RenderElement access>
            <RSSConfirmContentWrapper
              type={type}
              onClose={this.handleClose}
              message={message}
              showedit={this.handleEdit}
              name={this.name}
              btn1={btn1}
              hideButton1={hideButton1}
              btn2={btn2}
              hideButton2={hideButton2}
              onHover={onHover}
              hoverText1={hoverText1}
              hoverText2={hoverText2}
            />
          </RenderElement>
        </Dialog>
      </RenderElement>
    );
  }
}

export function openConfirmation({
  type, message, onAction, title, name, btn1, btn2, hideButton1, hideButton2, onHover, hoverText1, hoverText2
}) {

  confirmFn({
    type, message, onAction, title, name, btn1, btn2, hideButton1, hideButton2, onHover, hoverText1, hoverText2
  });
}

export default withStyles(styles2)(Confirmation);
